<app-filter-panel [fields]="fieldsConfig" [quickSearchFilter]="filters.name"
    quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="input-field p-input-icon-right ">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>
    <span class="input-field p-input-icon-right">
        <input pInputText placeholder="NIF/CIF" [(ngModel)]="filters.vatNumber.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.vatNumber.value" class="pi pi-times cursor-pointer"
            (click)="filters.vatNumber.value = null; search()"></i>
    </span>
    <span class="input-field p-input-icon-right" style="width: 250px;">
        <input pInputText placeholder="Nombre de contacto" [(ngModel)]="filters.description.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.description.value" class="pi pi-times cursor-pointer"
            (click)="filters.description.value = null; search()"></i>
    </span>

    <div class="input-field" style="width: 150px;">
        <p-dropdown placeholder="Especialidades" [options]="capabilities" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.capabilityId.filter.value" (onChange)="search()" showClear />
    </div>
    <div class="input-field" style="width: 150px;">
        <p-dropdown placeholder="Provincias" [options]="countriesRegions" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.countryRegionId.value" (onChange)="search();onCountryRegionChange($event)" showClear />
    </div>
    <div class="input-field" style="width: 200px;">
        <p-dropdown placeholder="Zona" [options]="zones" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.zoneId.filter.value" (onChange)="search()" showClear />
    </div>
    <span class="input-field p-input-icon-right" style="width: 200px;">
        <input pInputText placeholder="CP normal" [(ngModel)]="filters.zipCode.filter.filters[0].filters[0].filter.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.zipCode.filter.filters[0].filters[0].filter.value" class="pi pi-times cursor-pointer"
            (click)="filters.zipCode.filter.filters[0].filters[0].filter.value = null; search()"></i>
    </span>
    <span class="input-field p-input-icon-right" style="width: 200px;">
        <input pInputText placeholder="CP guardia" [(ngModel)]="filters.zipCodeGuard.filter.filters[0].filters[0].filter.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.zipCodeGuard.filter.filters[0].filters[0].filter.value" class="pi pi-times cursor-pointer"
            (click)="filters.zipCodeGuard.filter.filters[0].filters[0].filter.value = null; search()"></i>
    </span>
    
    <span class="input-field p-input-icon-right" style="max-width: 120px;">
        <input pInputText placeholder="Email" [(ngModel)]="filters.email.value" (keydown.enter)="search()" class="w-full" />
        <i *ngIf="filters.email.value" class="pi pi-times cursor-pointer" (click)="filters.email.value = null; search()"></i>
    </span>
    <span class="input-field p-input-icon-right" style="max-width: 120px;">
        <input pInputText placeholder="Teléfono" [(ngModel)]="filters.phoneNumber.value" (keydown.enter)="search()" class="w-full" />
        <i *ngIf="filters.phoneNumber.value" class="pi pi-times cursor-pointer" (click)="filters.phoneNumber.value = null; search()"></i>
    </span>

    <div class="input-field" style="width: 150px;">
        <p-dropdown placeholder="Estado" [options]="activeOptions" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.active.value" (onChange)="search()" showClear />
    </div>
    <div class="input-field" style="width: 150px;">
        <p-dropdown placeholder="Tipo" [options]="businessTypes" optionLabel="name" optionValue="value"
            [(ngModel)]="filters.typeOfBusiness.value" (onChange)="search()" showClear />
    </div>
</div>
-->

<p-table #grid [value]="workers" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="description">Nombre contacto <p-sortIcon field="description"></p-sortIcon></th>
            <th pSortableColumn="parentWorker.name">Supervisor <p-sortIcon field="parentWorker.name"></p-sortIcon></th>
            <th pSortableColumn="phone1">Teléfono <p-sortIcon field="phone1"></p-sortIcon></th>
            <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
            <th>Tipo</th>
            <th pSortableColumn="rating">Valoración <p-sortIcon field="rating"></p-sortIcon></th>
            <th pSortableColumn="hasSubmitInvoice">Presenta factura <p-sortIcon field="hasSubmitInvoice"></p-sortIcon></th>
            <th pSortableColumn="active">Activo <p-sortIcon field="active"></p-sortIcon></th>
            <th pSortableColumn="workload">Carga <p-sortIcon field="workload"></p-sortIcon></th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-worker let-columns="columns">
        <tr (dblclick)="edit(worker)">
            <td>{{worker.name}}</td>
            <td>{{worker.description}}</td>
            <td>{{worker.parentWorker?.name}}</td>
            <td>{{worker.phone1}}</td>
            <td>{{worker.email}}</td>
            <td>{{worker.parentWorkerId!=null?'Suboperario':'Operario'}}</td>
            <td><p-rating [(ngModel)]="worker.rating" [readonly]="true" /></td>
            <td>
                <i class="pi"
                    [ngClass]="{ 'text-green-500 pi-check-circle': worker.hasSubmitInvoice&&worker.parentWorkerId==null, 'text-red-500 pi-times-circle': !worker.hasSubmitInvoice&&worker.parentWorkerId==null }"></i>
            </td>
            <td>
                <i class="pi"
                    [ngClass]="{ 'text-green-500 pi-check-circle': worker.active, 'text-red-500 pi-times-circle': !worker.active }"></i>
            </td>
            
            
            <td>
                {{worker.workload??0}}% <i *ngIf="worker.manageYourAppointments" class="pi pi-info-circle color-info" style="color: var(--primary-color)" pTooltip="Gestiona su propia agenda"></i>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(worker)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <!--<p-button (click)="openChat(worker)" [rounded]="true" [text]="false">
                        <i class="pi pi-comments"></i>
                    </p-button>-->
                    <p-button *ngIf="allowWrite" (click)="edit(worker)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>